// The identity provider this environment signs in with, as one object.
//
// Core auth code (the UserManager, the session machine, sign-in, sign-out,
// token handling, routes) asks the provider what to do instead of checking
// which provider it is. Every difference between ForgeRock and Entra is a named
// member of the two provider objects, so this folder is the whole answer to
// "how do the providers differ?". ./forgerock/provider.js and
// ./entra/provider.js implement the same members, in the same order.
//
// Read off AppSettings at call time rather than captured at module load: the
// provider is fixed for a real deployment, but tests swap settings between
// cases on a shared module instance.

import AppSettings from "@/appsettings";

import { createEntraProvider } from "./entra/provider";
import { createForgeRockProvider } from "./forgerock/provider";

export const AUTH_PROVIDER_IDS = {
  ENTRA: "entra",
  FORGEROCK: "forgerock",
};

// Settings with no auth block (only partial test doubles) behave as ForgeRock,
// the provider every environment ran before Entra.
export const getAuthProvider = (appSettings = AppSettings) => {
  const auth = appSettings?.auth;
  if (auth?.provider === AUTH_PROVIDER_IDS.ENTRA) {
    return createEntraProvider(auth.entra ?? {});
  }
  return createForgeRockProvider(auth?.forgerock ?? {});
};
